import styled from 'styled-components';
import List from '../../../../components/Section/List';

export const ListProviders = styled(List)`
  width: 100%;
  list-style: none;
  border-radius: 3px;
  > div {
    width: 30%;
  }
  @media (max-width: 650px) {
    align-self: flex-start;
    padding: 16px;
  }
`;

export const ItemListProvider = styled.li`
  margin: 0;
`;

export const ProviderImg = styled.img`
  max-height: 40px;
  max-width: 65px;
  align-self: center;
`;

export const ProviderInfo = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px 24px 16px 24px;
  margin-left: 80px;
  justify-content: space-around;
  height: 220px;
  overflow: hidden;
  > p {
    font-size: 14px;
    line-height: 16px;
    font-weight: normal;
    margin: 0;
  }
  > div > span {
    font-size: 12px;
    font-weight: normal;
    color: #999999;
  }

  @media (max-width: 650px) {
    margin-left: 0;
  }
`;

export const ConfirmDisassociateInfo = styled(ProviderInfo)`
  font-weight: 500;
  margin: 0;
  height: auto;
  > img {
    margin: 0 auto;
  }
  @media (max-width: 650px) {
    height: 100%;
  }
`;

export const BoxInfoHelp = styled.div`
  display: flex;
  flex-direction: column;
  line-height: 24px;
  letter-spacing: 0px;
  color: ${props => props.theme.colors?.primary.main.color};
  > a {
    color: ${props => props.theme.colors?.primary.main.color};
    text-decoration: none;
    &:first-child {
      margin-bottom: 7px;
    }
    font-weight: 700;
  }
`;
